import React, { useState, useEffect, useRef } from 'react'
import './Banca.scss'
import Loading from '../../../../component/Loading/Loading'
import { getApiUrl } from '../../../../api/api'
import {
  getFromlocalstorage,
  getFromsessionstorage
} from '../../../../component/MaHoaDuLieu/MaHoaDuLieu'
import Notify from '../../../../component/Notify/Notify'

const gameData = [
  {
    name: 'Jili',
    img: '/fishing/jililogo.png',
    picImg: '/fishing/jdbright.png',
    GpId: 1020,
    logo: '/nohu/jili_s.png'
  },
  {
    name: 'JDB',
    img: '/fishing/jdblogo.png',
    picImg: '/fishing/jiliright.png',
    GpId: 1058,
    logo: '/nohu/0.png'
  },
  {
    name: 'FACHAI',
    img: '/fishing/gclogo.png',
    picImg: '/fishing/gcright.png',
    GpId: 1046,
    logo: '/nohu/fc.png'
  }
]

const Fishing = () => {
  const [notiMessage, setNotiMessage] = useState('')

  const dangnhap = localStorage.getItem('dangnhap')

  const [activePopup, setActivePopup] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [datagame, setdatagame] = useState(null)
  const canvasRef = useRef(null)
  const device = window.innerWidth > 540 ? 'd' : 'm'
  const userdata =
    JSON.parse(getFromsessionstorage('data_u')) ||
    JSON.parse(getFromlocalstorage('data_u'))

  const [activeIndex, setActiveIndex] = useState(0)

  const togglePop = firmcode => {
    setActivePopup(firmcode)
  }

  const closePop = () => {
    setActivePopup(null)
  }

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    let width = (canvas.width = window.innerWidth)
    let height = (canvas.height = window.innerHeight)
    const particleCount = 100
    const particles = []
    const img = new Image()
    img.src = '/fishing/bubble.png'

    function createParticle () {
      return {
        x: Math.random() * width,
        y: Math.random() * height + height,
        v: 5 + Math.random() * 5,
        s: 5 + Math.random() * 40,
        update () {
          this.x += Math.sin(this.s)
          this.s = Math.max(0, this.s - 0.1)
          this.y -= this.v * 0.35
          if (this.y < 0 || this.x < 0 || this.x > width) {
            this.x = Math.random() * width
            this.y = height + Math.random() * 100
            this.v = 5 + Math.random() * 5
            this.s = 5 + Math.random() * 40
          }
        },
        draw () {
          if (img.complete && img.naturalWidth !== 0) {
            ctx.drawImage(img, this.x, this.y, this.s, this.s)
          }
        }
      }
    }

    function render () {
      ctx.clearRect(0, 0, width, height)
      particles.forEach(p => {
        p.update()
        p.draw()
      })
      requestAnimationFrame(render)
    }

    function resize () {
      width = canvas.width = window.innerWidth
      height = canvas.height = window.innerHeight
    }

    window.addEventListener('resize', resize)

    img.onload = () => {
      for (let i = 0; i < particleCount; i++) {
        particles.push(createParticle())
      }
      render()
    }

    img.onerror = () => {
      console.error('Không thể tải hình ảnh:', img.src)
    }

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  const handelgame = async GpId => {
    try {
      setIsLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/postdanhsachgame`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          GpId
        })
      })
      if (response.ok) {
        const data = await response.json()

        const fishingGames = data.seamlessGameProviderGames.filter(
          g =>
            g.gameInfos &&
            g.gameInfos[0] &&
            g.gameInfos[0].gameName &&
            g.gameInfos[0].gameName.toLowerCase().endsWith('fishing')
        )

        setdatagame(fishingGames)
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  const hanldePostWidthdraw = async (gameProviderId, gameId) => {
    try {
      setIsLoading(true)
      const response = await fetch(`${getApiUrl('backend')}/launch_game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          portfolio: 'SeamlessGame',
          device,
          gameProviderId,
          gameId,
          userData: userdata,
          productId: null
        })
      })
      const data = await response.json()
      console.log(data)

      if (data.message) {
        setIsLoading(false)
        setNotiMessage(data.message)
      } else {
        if (data.url) {
          window.location.href = data.url
          setIsLoading(false)
        }
      }
    } catch (error) {
      setIsLoading(false)
      console.error('Failed to fetch API: ', error)
    }
  }

  const handleTabClick = index => {
    setActiveIndex(index)
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type='error'
        />
      )}

      <div className='by-box'>
        <canvas
          ref={canvasRef}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0
          }}
        />
        <div className='containerfishing wrapfishing'>
          <div className='title'>
            <img src='/fishing/title.png' alt='Fishing Title' />
          </div>

          <div className='live-box nobackgr'>
            <div className='container'>
              <div id='liveList' className='live-game tab tab-slideshow'>
                <div className='tabframe backgrca'>
                  <div className='swiper-container'>
                    <div className='tab_ctrl ctrl swiper-wrapper'>
                      {gameData.map((item, index) => (
                        <a
                          key={item.id}
                          className={`swiper-slide tab_btn ${
                            index === activeIndex ? 'active' : ''
                          }`}
                          href='#!'
                          onClick={() => handleTabClick(index)}
                        >
                          <img
                            src={item.logo}
                            alt={`${item.name}-logo`}
                            className='live-provider-logo-img'
                          />
                          <span className='name'>{item.name}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
                <div className='tab_main main'>
                  {gameData.map((item, index) => (
                    <div
                      key={index}
                      className={`tab_item item ${
                        index === activeIndex ? 'active' : ''
                      }`}
                      style={{
                        display: index === activeIndex ? 'flex' : 'none'
                      }}
                    >
                      <div className='content-box animated fadeInLeft gapbox'>
                        <img
                          src={item.img}
                          alt={item.name}
                          className='live-provider-img'
                        />
                        <a
                          className='play-btn'
                          href='#!'
                          onClick={() => {
                            togglePop(item.name)
                            handelgame(item.GpId)
                          }}
                        >
                          PLAY NOW
                        </a>
                      </div>
                      <div className='pic animated fadeInRight'>
                        <img src={item.picImg} alt={item.name} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div id='popupList'>
            <Loading isLoading={isLoading} />
            {activePopup && datagame && (
              <div className='popup active' data-firmcode={activePopup}>
                <div className='popup-title'>{activePopup}</div>
                <div className='popup-close' onClick={closePop}></div>
                <div className='popup__game'>
                  {datagame.map((game, index) => (
                    <a
                      key={index}
                      className='popup__game-item'
                      href='#!'
                      onClick={e => {
                        e.preventDefault()
                        if (!dangnhap) {
                          setNotiMessage('Vui lòng đăng nhập để chơi game')
                        } else {
                          hanldePostWidthdraw(game.gameProviderId, game.gameID)
                        }
                      }}
                    >
                      <img
                        className='popup__game-icon'
                        src={game.gameInfos[0].gameIconUrl}
                        alt={game.gameInfos[0].gameName}
                      />
                      <div className='popup__game-name'>
                        {game.gameInfos[0].gameName}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
          <canvas ref={canvasRef} className='bubble' />
        </div>
      </div>
    </>
  )
}

export default Fishing
